import { appstr } from "./appstr.js";

export function formatArray(arr, useOr) {
  //Shamelessly stolen from stackOverflow with an extremely minor change.
  var clauseChar = useOr ? appstr("or") : "&";
  //TODO: Hook up the clause Char here.

  var outStr = "";
  if (arr.length === 1) {
    outStr = arr[0];
  } else if (arr.length === 2) {
    //joins all with & but no commas
    outStr = arr.join(" & ");
  } else if (arr.length > 2) {
    //joins all with commas, but last one gets &
    outStr = arr.slice(0, -1).join(", ") + " & " + arr.slice(-1);
  }
  return outStr;
}
